require('./bootstrap')

import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import $ from 'jquery'
import { createApp, provide, ref } from 'vue'
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import Select2 from 'vue3-select2-component'
import Loading from './components/Loading.vue'
window.$ = window.jQuery = $

const app = createApp({
  setup() {
    const loadingStatus = ref(false)
    provide('loading', loadingStatus)
  },
})

//// register components manually
// app.component("component-name-tag", ComponentName);
////

///// register components automatically
const files = require.context('./', true, /\.vue$/i)
files
  .keys()
  .map((key) =>
    app.component(key.split('/').pop().split('.')[0], files(key).default)
  )
////

app.component('Select2', Select2)
app.component('Datepicker', Datepicker)
app.component('loading', Loading)
app.use(PerfectScrollbar)
app.mount('#main')
